import { client } from '../client';

export interface GetPricingsParams {
  for_user_id?: number;
}

export interface Pricings {
  code: string;
  label: string;
  amount: number;
  currency: string;
  collect_insurance_info: boolean;
  case_types: string[];
  is_active: boolean;
  payment_options?: string[];
  amount_after_plan?: number;
  plan_decision_reason?: string;
  plan_group_id?: string;
  plan_free_remaining?: number;
  plan_percent_off?: number;
  created_at: string;
}

export const getPricings = async (userId?: number): Promise<Pricings[]> => {
  let data;
  if (userId) {
    const response = await client.get(`/pricings`, { params: { for_user_id: userId } });
    data = response.data;
  } else {
    const response = await client.get(`/pricings`);
    data = response.data;
  }
  return data;
};
